import classNames from 'classnames';
import React from 'react';
import { componentFromProp, defaultProps } from 'recompose';

const Component = componentFromProp('tag');

const FormControl = ({ children, className, icon, readOnly, ...otherProps }) => (
  <Component {...{
    className: classNames(`form-control${readOnly ? '-plaintext' : ''}`, className),
    readOnly,
    ...otherProps
  }}>
    {children}
  </Component>
);

export default defaultProps({ tag: 'input' })(FormControl);



// WEBPACK FOOTER //
// ./src/components/proxy/form-control.js